const cup = (
  <path
    d="M12 2H14C13.6667 3.5 12.5 6.5 10.5 6.5M4 2H2C2.33333 3.5 3.5 6.5 5.5 6.5M7 7.86243V10.5H6V12M6 12L5.5 12C5.5 12 5.67465 12.6507 5.5 13C5.37651 13.247 5 13.5 5 13.5V14.5H11V13.5C11 13.5 10.6235 13.247 10.5 13C10.3254 12.6507 10.5 12 10.5 12H10M6 12H10M10 12V10.5H9V7.88457M4 1H12C11.8333 3.33333 10.8 8 8 8C5.2 8 4.16667 3.33333 4 1Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
export default cup;
